import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Button, Modal, Panel } from "components/bootstrap";
import DocumentationLink from "components/support/DocumentationLink";
import FormDataContext from "integrations/contexts/FormDataContext";
import { ApiContext } from "integrations/aws/context/Api";
import { SidebarContext } from "integrations/aws/context/Sidebar";
import useFetch from "integrations/hooks/useFetch";
import FormWrap from "integrations/aws/common/FormWrap";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import { ApiRoutes, DocsRoutes } from "integrations/aws/common/Routes";
import { renderOptions } from "integrations/aws/common/Options";
import formValidation from "integrations/aws/utils/formValidation";
import Spinner from "components/common/Spinner";
import useProductName from "brand-customization/useProductName";
import { toAWSRequest } from "integrations/aws/common/formDataAdapter";
import FormAdvancedOptions from "../FormAdvancedOptions";
const AutoSetupContent = styled.div`
  margin-bottom: 9px;
`;
const LoadingContent = styled(Modal.Body)`
  text-align: center;
`;
const StyledSpinner = styled(Spinner)`
  font-size: 48px;
  color: #702785;
`;
const LoadingMessage = styled.p`
  font-size: 16px;
  font-weight: bold;
  padding-top: 15px;
  color: #a6afbd;
`;
const KinesisStreams = ({ onChange, onSubmit, toggleSetup = () => {
} }) => {
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { availableStreams, setLogData } = useContext(ApiContext);
  const { clearSidebar, setSidebar } = useContext(SidebarContext);
  const productName = useProductName();
  const [logDataStatus, setLogDataUrl] = useFetch(
    null,
    (response) => {
      setLogData(response);
      onSubmit();
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream ? formData.awsCloudWatchKinesisStream.value : ""
    })
  );
  useEffect(() => {
    setSidebar(
      /* @__PURE__ */ React.createElement(Panel, { bsStyle: "info", header: /* @__PURE__ */ React.createElement("span", null, t("aws_kinesis_existing_streams.sidebar_title")) }, /* @__PURE__ */ React.createElement(AutoSetupContent, null, /* @__PURE__ */ React.createElement("p", null, t("aws_kinesis_existing_streams.sidebar_requirement")), /* @__PURE__ */ React.createElement("p", null, t("aws_kinesis_existing_streams.sidebar_auto_setup", { productName }))), /* @__PURE__ */ React.createElement(
        Button,
        {
          onClick: () => {
            clearSidebar();
            toggleSetup();
          },
          type: "button"
        },
        t("aws_kinesis_existing_streams.setup_automatically_button")
      ))
    );
  }, [clearSidebar, productName, setSidebar, t, toggleSetup]);
  useEffect(() => {
    if (logDataStatus.error) {
      setLogDataUrl(null);
      setFormError({
        full_message: logDataStatus.error,
        nice_message: /* @__PURE__ */ React.createElement("span", null, t("aws_kinesis_existing_streams.no_logs_error"))
      });
    }
  }, [logDataStatus.error, setLogDataUrl, t]);
  const handleSubmit = () => {
    setLogDataUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS.HEALTH_CHECK);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Modal, { show: logDataStatus.loading, bsSize: "small", onHide: () => {
  }, closable: false }, /* @__PURE__ */ React.createElement(LoadingContent, null, /* @__PURE__ */ React.createElement(StyledSpinner, null), /* @__PURE__ */ React.createElement(LoadingMessage, null, t("aws_kinesis_existing_streams.loading_message")))), /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("aws_kinesis_existing_streams.verify_button"),
      loading: logDataStatus.loading,
      error: formError,
      disabled: formValidation.isFormValid(["awsCloudWatchKinesisStream"], formData),
      title: t("aws_kinesis_existing_streams.title"),
      description: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("aws_kinesis_existing_streams.description_list")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "aws_kinesis_existing_streams.description_docs",
          components: {
            docsLink: /* @__PURE__ */ React.createElement(
              DocumentationLink,
              {
                page: DocsRoutes.INTEGRATIONS.AWS.AWS_KINESIS_CLOUDWATCH_INPUTS,
                text: t("aws_kinesis_existing_streams.docs_link_text")
              }
            )
          }
        }
      )))
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsCloudWatchKinesisStream",
        type: "select",
        fieldData: formData.awsCloudWatchKinesisStream,
        onChange,
        label: t("aws_kinesis_existing_streams.select_stream_label"),
        required: true
      },
      renderOptions(availableStreams, t("aws_kinesis_existing_streams.select_stream_placeholder"))
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  ));
};
export default KinesisStreams;
